import React, { useCallback, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { SubjectPropType } from '../../../abilities/proptypes';
import SendMailButton from './SendMailButton';
import { NURSE_REQUEST_ENTITY } from '../../../mailTemplates/entities';
import { IdPropType } from '../../../../proptypes/basic';
import { PrefillMailPropType } from '../../../mails/proptypes';
// import { useCallbackFunc } from '../../../hooks';
import CareNeedSelect from '../../../careNeeds/components/CareNeedSelect';
import { useNurseRequestSend } from '../../../nurseRequests/hooks';
import { YupId } from '../../../form/schema';
// import { selectAllEmployees } from '../../../employees/employeesSlice';

const SendNurseRequestButton = ({
    name,
    disabled,
    customerId,
    careNeedId,
    onSent,
    subject,
    action,
    className,
    variant,
    color,
    size,
    label,
    fullWidth,
    prefill,
    ellipsis,
}) => {
    // const employees = useSelector(selectAllEmployees);

    const { prepareExtraEntities, handleSent: handleNurseRequestSent } = useNurseRequestSend(
        customerId,
        careNeedId
    );

    const extraFields = useMemo(
        () => [
            {
                name: 'careNeedId',
                component: CareNeedSelect,
                label: 'BK-Bedarf',
                customerId,
                validate: YupId().required('Pflichtfeld'),
                initial: careNeedId,
            },
        ],
        [customerId, careNeedId]
    );

  /*
    const getAgencyIdsForContracts = useCallbackFunc((emails) =>
        emails
            .map((email) => employees.find((contact) => contact.email === email))
            .filter((employee) => !!employee)
            .reduce((carry, employee) => {
                if (!carry.includes(employee.agencyId)) {
                    carry.push(employee.agencyId);
                }
                return carry;
            }, [])
    );
    */

    const handleSent = useCallback(
        async (args) => {
            const results = await handleNurseRequestSent(args);

            if (onSent) {
                await onSent(results);
            }
        },
        [handleNurseRequestSent, onSent]
    );

    return (
        <SendMailButton
            name={name}
            variant={variant}
            color={color}
            disabled={disabled}
            action={action}
            subject={subject}
            entity={NURSE_REQUEST_ENTITY}
            entityId={customerId}
            onSent={handleSent}
            extraEntities={prepareExtraEntities}
            extraFields={extraFields}
            className={className}
            size={size}
            label={label || 'BK-Anfrage versenden'}
            fullWidth={fullWidth}
            prefill={prefill}
            ellipsis={ellipsis}
        />
    );
};

SendNurseRequestButton.propTypes = {
    name: PropTypes.string,
    customerId: IdPropType.isRequired,
    careNeedId: IdPropType,
    onSent: PropTypes.func,
    disabled: PropTypes.bool,
    subject: SubjectPropType,
    action: PropTypes.string,
    variant: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.node,
    fullWidth: PropTypes.bool,
    prefill: PrefillMailPropType,
    ellipsis: PropTypes.bool,
};

SendNurseRequestButton.defaultProps = {
    name: null,
    careNeedId: null,
    onSent: null,
    disabled: false,
    subject: null,
    action: null,
    variant: undefined,
    color: undefined,
    size: undefined,
    className: null,
    label: null,
    fullWidth: false,
    prefill: null,
    ellipsis: false,
};

export default SendNurseRequestButton;
